import { render, staticRenderFns } from "./AudioClip.vue?vue&type=template&id=6c6d9744&scoped=true"
import script from "./AudioClip.vue?vue&type=script&lang=ts"
export * from "./AudioClip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6d9744",
  null
  
)

export default component.exports